"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _OutsideClickWrapper = _interopRequireDefault(require("../../OutsideClickWrapper/OutsideClickWrapper"));

var _reactstrap = require("reactstrap");

require("./LabelInput.scss");

require("./LabelInputDark.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LabelInput = function LabelInput(props) {
  var _useState = (0, _react.useState)(props.value),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      focus = _useState4[0],
      setOnFocus = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      removeErrorOnEmpty = _useState6[0],
      setRemoveErrorOnEmpty = _useState6[1];

  var inputRef = (0, _react.useRef)(null);

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      showPassword = _useState8[0],
      setShowPassword = _useState8[1];

  var _useState9 = (0, _react.useState)(props.rows),
      _useState10 = _slicedToArray(_useState9, 2),
      rows = _useState10[0],
      setRows = _useState10[1];

  (0, _react.useEffect)(function () {
    if (props.value === '') {
      setRemoveErrorOnEmpty(true);
    } else {
      setRemoveErrorOnEmpty(false);
    }

    setValue(props.value);
  }, [props.value]);

  var onChange = function onChange(e) {
    props.focus && setOnFocus(true);
    var inputValue = e.target.value;
    inputValue === '' ? setRemoveErrorOnEmpty(true) : setRemoveErrorOnEmpty(false);

    if (props.maxLength) {
      if (e.target.value.length <= e.target.maxLength) {
        setValue(inputValue);
        props.onChange(inputValue);
      }
    } else {
      setValue(inputValue);
      props.onChange(inputValue);
    }
  };

  var onAutosize = function onAutosize(e) {
    var textareaLineHeight = props.withNumber ? 21 : 24;
    var previousRows = e.target.rows;
    e.target.rows = props.rows;
    var currentRows = ~~(e.target.scrollHeight / textareaLineHeight);

    if (currentRows === previousRows) {
      e.target.rows = currentRows;
    }

    if (currentRows >= props.maxRows) {
      e.target.rows = props.maxRows;
      if (previousRows !== props.maxRows) e.target.scrollTop = e.target.scrollHeight;
    }

    setRows(currentRows < props.maxRows ? currentRows : props.maxRows);
  };

  var onChangeMultiline = function onChangeMultiline(e) {
    props.focus && setOnFocus(true);
    var inputValue = e.target.value;
    inputValue === '' ? setRemoveErrorOnEmpty(true) : setRemoveErrorOnEmpty(false);

    if (props.maxLength) {
      if (e.target.value.length <= e.target.maxLength) {
        setValue(inputValue);
        props.onChange(inputValue);
      }
    } else {
      setValue(inputValue);
      props.onChange(inputValue);
    }

    onAutosize(e);
  };

  var onClick = function onClick() {
    inputRef.current.focus(); // props.focus && setOnFocus(true);
  };

  var onValidate = function onValidate(e) {
    setOnFocus(false);

    if (props.onValidate) {
      var inputValue = e.target.value;
      props.onValidate(inputValue);
    }
  };

  var onKeyDown = function onKeyDown(e) {
    var regex = new RegExp('^[Ññíóáéú a-zA-Z 0-9_-]+$');

    if (e.key.toUpperCase() === 'ENTER') {
      props.onEnter();
    }

    if (props.onlyAlphanumeric && !regex.test(e.key)) e.preventDefault();
    if (props.onlyNumbers && !['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) e.preventDefault();
  };

  var tooltipRef = (0, _react.useRef)();
  return /*#__PURE__*/_react["default"].createElement(_OutsideClickWrapper["default"], {
    action: function action() {
      return setOnFocus(false);
    },
    className: "gcl-label-input-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-labelInput ".concat(props.disabled ? 'disabled' : '', " ").concat(value.length <= 0 ? 'empty' : '', " ").concat(focus ? 'focused' : '', " ").concat(props.error && !removeErrorOnEmpty ? 'error' : '', " ").concat(props.multiline ? 'multiline' : '', " ").concat(props.withNumber ? 'withNumber' : '', " ").concat(props.className),
    onClick: onClick,
    ref: tooltipRef
  }, props.numberInput && /*#__PURE__*/_react["default"].createElement("div", {
    className: "containerNumber"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "inputNumberContainer"
  }, props.numberInput), /*#__PURE__*/_react["default"].createElement("div", {
    className: "lineContainerNumber"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-labelInput-input-wrapper"
  }, (value.length > 0 || value === 0 || value !== '' || focus) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "inputTitle ".concat(props.withNumber ? 'withNumber' : '')
  }, /*#__PURE__*/_react["default"].createElement("span", null, props.label), props.required && /*#__PURE__*/_react["default"].createElement("span", {
    className: "required"
  }, "*")), props.multiline ? /*#__PURE__*/_react["default"].createElement("textarea", {
    rows: rows,
    type: props.password && !showPassword ? 'password' : props.onlyNumbers ? 'number' : 'text',
    tabIndex: props.tabIndex,
    ref: inputRef,
    className: "".concat(props.focus ? 'gcl-labelInput-span-focus' : '', " ").concat(props.withNumber ? 'multiline-textareaWithNumber' : '', " multiline-textarea"),
    placeholder: !props.required && !focus ? props.placeholder : undefined,
    onChange: !props.disabled ? onChangeMultiline : undefined,
    value: value,
    required: props.required,
    disabled: props.disabled,
    min: props.minValue,
    maxLength: props.maxLength,
    onFocus: props.focus ? function () {
      return setOnFocus(true);
    } : undefined,
    onBlur: function onBlur(e) {
      return onValidate(e);
    },
    onKeyDown: props.onlyNumbers ? onKeyDown : undefined,
    onClick: function onClick(e) {
      return onAutosize(e);
    }
  }) : /*#__PURE__*/_react["default"].createElement("input", {
    type: props.password && !showPassword ? 'password' : props.onlyNumbers ? 'number' : 'text',
    autoComplete: props.noAutofill ? 'new-password' : undefined,
    tabIndex: props.tabIndex,
    ref: inputRef,
    className: props.focus ? 'gcl-labelInput-span-focus' : '',
    placeholder: !props.required && !focus ? props.placeholder : undefined,
    onChange: !props.disabled && onChange,
    value: value,
    required: props.required,
    disabled: props.disabled,
    min: props.minValue,
    maxLength: props.maxLength,
    onFocus: props.focus ? function () {
      return setOnFocus(true);
    } : undefined,
    onBlur: function onBlur(e) {
      return onValidate(e);
    },
    onKeyDown: props.onlyNumbers || props.onlyAlphanumeric ? onKeyDown : undefined
  }), props.required && !focus && value.length === 0 && /*#__PURE__*/_react["default"].createElement("label", {
    className: 'labelRequired' + (props.password ? ' withPassword' : '')
  }, props.placeholder, /*#__PURE__*/_react["default"].createElement("span", {
    className: "required"
  }, "*"))), props.error && !props.tooltipInfo && !props.password && !removeErrorOnEmpty && !props.customIcon && /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon close",
    onClick: function onClick() {
      setValue('');
      setRemoveErrorOnEmpty(true);
    }
  }), props.tooltipInfo && /*#__PURE__*/_react["default"].createElement("i", {
    className: props.error && !removeErrorOnEmpty ? "gcl-icon exclamation" : "gcl-icon info ".concat(value.length > 0 ? 'iconWithText' : ''),
    id: props.idTooltip
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    placement: "bottom-end",
    target: props.idTooltip,
    hideArrow: true,
    className: "gcl-labelInput-tooltip"
  }, props.tooltipInfoMessage)), props.customIcon && /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-labelInput__custom_icon gcl-icon ".concat(props.customIcon, " ").concat(value.length > 0 ? 'iconWithText' : '')
  }), props.password && /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon ".concat(showPassword ? 'show' : 'not-show-pass', " ").concat(value.length > 0 ? 'iconWithText' : '', " ").concat(props.error && !removeErrorOnEmpty ? 'error' : ''),
    onMouseDown: function onMouseDown() {
      setShowPassword(!showPassword);
    },
    onMouseUp: function onMouseUp() {
      setShowPassword(!showPassword);
    },
    onMouseOut: function onMouseOut() {
      setShowPassword(false);
    }
  })), props.error && props.errorMessage && !removeErrorOnEmpty && /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-labelInput-error"
  }, props.errorMessage), props.tooltip != null && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    placement: "top",
    target: tooltipRef,
    trigger: 'hover',
    boundariesElement: "window"
  }, props.tooltip));
};

LabelInput.propTypes = {
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  //initialInput Value
  className: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  label: _propTypes["default"].string,
  error: _propTypes["default"].bool,
  errorMessage: _propTypes["default"].string,
  idTooltip: _propTypes["default"].string,
  tooltipInfo: _propTypes["default"].bool,
  tooltipInfoMessage: _propTypes["default"].string,
  tooltip: _propTypes["default"].string,
  password: _propTypes["default"].bool,
  focus: _propTypes["default"].bool,
  onChange: _propTypes["default"].func.isRequired,
  tabIndex: _propTypes["default"].number,
  disabled: _propTypes["default"].bool,
  onlyNumbers: _propTypes["default"].bool,
  minValue: _propTypes["default"].string,
  onkeydown: _propTypes["default"].string,
  multiline: _propTypes["default"].bool,
  rows: _propTypes["default"].number,
  maxRows: _propTypes["default"].number,
  maxLength: _propTypes["default"].number,
  noAutofill: _propTypes["default"].bool,
  withNumber: _propTypes["default"].bool,
  numberInput: _propTypes["default"].number
};
LabelInput.defaultProps = {
  value: '',
  className: '',
  placeholder: '',
  label: '',
  error: false,
  idTooltip: 'idTooltipDefault',
  tooltipInfo: false,
  password: false,
  focus: false,
  disabled: false,
  rows: 1,
  maxRows: 5,
  onChange: function onChange() {},
  onValidate: function onValidate() {}
};
var _default = LabelInput;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/Input/LabelInput/LabelInput.js
// module id = 697
// module chunks = 0